import { Skeleton } from '../../../Skeleton'

import * as styles from './ChatroomInputFormSkeleton.module.css'

function ChatroomInputFormSkeleton() {
  return (
    <div className={styles.form}>
      <Skeleton className={styles.avatar} />
      <div className={styles.body}>
        <Skeleton className={styles.templateRow} />
        <Skeleton className={styles.wysiwyg} />
        <div className={styles.actions}>
          <Skeleton className={styles.chip} />
          <Skeleton className={styles.chip} />
          <Skeleton className={styles.chipWide} />
          <div className={styles.actionsSpacer} />
          <Skeleton className={styles.chip} />
          <Skeleton className={styles.chip} />
        </div>
      </div>
    </div>
  )
}

export default ChatroomInputFormSkeleton
